import React from 'react';
import FlowRendererComponent from 'conversie-flow-bundle/assets/js/components/flow/renderers/FlowRendererComponent';

/* Conversion Fields */
import ConversionFlowFieldChoice from "./fields/ConversionFlowFieldChoice";
import ConversionFlowFieldChoiceExtended from "./fields/ConversionFlowFieldChoiceExtended";

/* Components */
import ConversionComponentSummary from './components/ConversionComponentSummary';
import ConversionFlowComponentFinanceCalculator from './components/ConversionFlowComponentFinanceCalculator';
import ConversionFlowComponentLeaseConfigurator from './components/ConversionFlowComponentLeaseConfigurator';
import ConversionFlowComponentShortLeaseCalculator from "./components/ConversionFlowComponentShortLeaseCalculator";
import ConversionFlowComponentAccessories from "./components/ConversionFlowComponentAccessories";
import ConversionFlowComponentPurchaseTypeConfigurator from "./components/ConversionFlowComponentPurchaseTypeConfigurator";

/* Fields */
import ConversionFlowFieldHeader from "./fields/ConversionFlowFieldHeader";
import ConversionFlowFieldMoney from "./fields/ConversionFlowFieldMoney";
import ConversionFlowFieldAccessories from "./fields/ConversionFlowFieldAccessories";

export default function ConversionFlowComponentRenderer({ flow, uspsLease, id = 'form' }) {
    return (
        <FlowRendererComponent
            components={flow?.form?.components}
            path={`form.components`}
            id={`${id}-${flow?.flowId}.components`}
            renderComponent={(component, props) => {
                const { name } = component;

                if (name === 'summary') {
                    return (
                        <ConversionComponentSummary
                            summary={flow?.summary}
                        />
                    );
                }

                if (name === 'finance-calculator') {
                    return <ConversionFlowComponentFinanceCalculator {...props} />;
                }

                if (name === 'short_lease') {
                    return <ConversionFlowComponentShortLeaseCalculator {...props} />;
                }

                if (name === 'lease-configurator') {
                    return <ConversionFlowComponentLeaseConfigurator
                        {...props}
                        uspsLease={uspsLease}
                    />;
                }

                if(name === 'accessories') {
                    return <ConversionFlowComponentAccessories {...props} />
                }

                if (name === 'purchase-type-configurator') {
                    return <ConversionFlowComponentPurchaseTypeConfigurator
                        {...props}
                        uspsLease={uspsLease}
                    />;
                }
            }}
            renderField={(field, props) => {

                if (field.type === 'money') {
                    return (
                        <ConversionFlowFieldMoney
                            {...props}
                        />
                    );
                }

                if (field.type === 'header') {
                    return (
                        <ConversionFlowFieldHeader
                            {...props}
                        />
                    );
                }

                if (field.type === 'choice-radio') {
                    return <ConversionFlowFieldChoiceExtended {...props} field={{ ...field, name: field.view ? `${field.name} form-group--flow-view-${field.view}` : field.name }} inputType="radio" />;
                }

                if (field.type === 'choice-checkbox') {
                    if (field.name.startsWith('accessories_')) {
                        return (
                            <ConversionFlowFieldAccessories
                                {...props}
                                field={field}
                                inputType="checkbox"
                            />
                        );
                    }

                    return (
                        <ConversionFlowFieldChoice
                            {...props}
                            inputType="checkbox"
                        />
                    );
                }
            }}
        />
    )
}
